import { IncomingMessage, ServerResponse } from 'http'
import type { NextApiRequest, NextApiResponse } from 'next'

import { CustomNextApiRequest } from '../_utils/routeHandler'
import { getCookie } from 'cookies-next'
import jwt from 'jsonwebtoken'

const getCurrentSessionJwt = async (
	req: NextApiRequest | IncomingMessage,
	res: NextApiResponse | ServerResponse
): Promise<SessionJwt> => {
	try {
		const jwtToken = getCookie('.auth', { req, res }) as string
		if (!jwtToken) return null

		const jwtTokenPayload = validateJwtToken(jwtToken)
		if (!jwtTokenPayload) return null

		return {
			token: jwtToken,
			payload: jwtTokenPayload,
		}
	} catch (err) {
		return null
	}
}

export const validateJwtToken = (token: string): JwtPayload => {
	if (!token) {
		return null
	}
	try {
		const decoded = jwt.verify(token, process.env.JWT_SECRET_KEY)
		if (!decoded) return null

		const result: JwtPayload = {
			userId: decoded['sub'],
			expires: new Date(decoded['exp'] * 1000),
		}

		return result
	} catch (e) {
		return null
	}
}

export const getUserIdForLogging = (req: CustomNextApiRequest): number => {
	const authToken = getCookie('.auth', { req }) as string

	if (!authToken) {
		return null
	}

	const session = validateJwtToken(authToken)

	return session ? session?.userId : null
}

export default getCurrentSessionJwt
